import axios from "axios";
import apiURI from "./Api";

export default class MarketplaceService {
  async postUploadBannner(images, type) {
    if (type === "main") return await this.postUploadMainBannner(images);

    if (type === "sub1") return await this.postUploadSubBannner1(images);

    if (type === "sub2") return await this.postUploadSubBannner2(images);

    if (type === "sub3") return await this.postUploadSubBannner3(images);

    throw new Error("Não existe esse 'type'");
  }

  async postUploadMainBannner(images) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/marketplace/configuration/setMainBanner`,
      data: images,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    }).catch((e) => console.log(e));

    return response.data;
  }

  async postUploadSubBannner1(images) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/marketplace/configuration/setSubBanner1`,
      data: images,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    }).catch((e) => console.log(e));

    return response.data;
  }

  async postUploadSubBannner2(images) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/marketplace/configuration/setSubBanner2`,
      data: images,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    }).catch((e) => console.log(e));

    return response.data;
  }

  async postUploadSubBannner3(images) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/marketplace/configuration/setSubBanner3`,
      data: images,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    }).catch((e) => console.log(e));

    return response.data;
  }

  async getConfiguration() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/marketplace/configuration/getconfiguration`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }
}
